import React from "react"
import PageBuilderActions from "./actions/PageBuilderActions"
import PageBuilderConstants from "./constants/PageBuilderConstants"

class ResizeHandle extends React.Component{

  constructor(props) {
    super(props)
    this.offset = null;
    this.movingLeftToRight = null;
    this._drag = this._drag.bind(this);
    this._start = this._start.bind(this);
  }

  componentDidMount() {
    // build draggable plugin
    $(this.refs.handle).draggable({}, {
        grid: [this.props.gridSize, 0],
        cursor: 'ew-resize'
      }, {
      containment: this.refs.containment,
      drag:  this._drag,
      start: this._start
    });
  }

  componentDidUpdate() {
    // antipattern: force handle left - because jQuery UI needs some help
    $(this.refs.handle).attr('style', 'left: ' + this.getHandlePosition() + ' !important');
  }

  componentWillUnmount() {
    // destroy draggable plugin
    $(this.refs.handle).draggable('destroy');
  }

  render() {
    var handleStyles = {
      left: this.getHandlePosition()
    };

    var containmentStyles = {
      left: this.getStartPosition(),
      right: this.getEndPosition()
    };

    return (
      <div className="resizeHandleWrapper">
        <div className="resize-handle" ref="handle" style={handleStyles}></div>
        <div className="resize-handle-containment" ref="containment" style={containmentStyles}></div>
      </div>
    );
  }

  /**
  * Gets the grid width in pixels
  *
  * @returns {integer}
  */
  gridWidth() {
    return this.props.gridSize * 12;
  }

  /**
  * Gets the handle position in pixels
  *
  * @returns {string}
  */
  getHandlePosition() {
    var position = 0;

    for (var i = 0, ilen = this.props.columns.length; i < ilen; i++) {
      var currentColumn = this.props.columns[i];

      position = position + currentColumn.size;

      if (currentColumn.id === this.props.leftColumn.id) {
        break;
      }
    }

    // make fine adjustments
    var fineAdjustment = 2;
    if (position > 0 && position < 3) {
      fineAdjustment = 2
    } else if (position >= 3 && position < 6) {
      fineAdjustment = 1
    } else if (position >= 6 && position < 9) {
      fineAdjustment = -1
    } else if (position >= 9) {
      fineAdjustment = -2
    }
    return (position * this.props.gridSize) - fineAdjustment + 'px'
  }

  /**
  * Gets the start position (left edge) of the column in pixels
  *
  * @returns {integer}
  */
  getStartPosition() {
    var position = 0;

    for (var i = 0, ilen = this.props.columns.length; i < ilen; i++) {
      var currentColumn = this.props.columns[i];

      if (currentColumn.id === this.props.leftColumn.id) {
        position = position + 1;
        break;
      } else {
        position = position + currentColumn.size;
      }
    }

    return ((position * this.props.gridSize) - (this.props.gridSize / 2) - this.props.handleSize) + 'px'
  }

  /**
  * Gets the end position (right edge) of the column in grid size units
  *
  * @returns {integer}
  */
  getEndPosition() {
    var position = 0;

    for (var i = 0, ilen = this.props.columns.length; i < ilen; i++) {
      var currentColumn = this.props.columns[i];

      position = position + currentColumn.size;

      if (currentColumn.id === this.props.rightColumn.id) {
        break;
      }
    }

    return (this.gridWidth() - ((position - 1) * this.props.gridSize) - (this.props.gridSize) + this.props.handleSize)  + 'px'
  }

  /*
  * @returns {boolean}
  */
  isOffsetChanged(offset) {
    if (this.offset && offset && this.offset.top === offset.top && this.offset.left === offset.left) {
      return false;
    } else {
      this.movingLeftToRight = (offset.left - this.offset.left > 0) ? true : false;
      this.offset = offset;
      return true;
    }
  }

  _drag(event, ui) {
    if (this.isOffsetChanged(ui.offset)) {
      if (this.movingLeftToRight) {
        PageBuilderActions.resizeColumn(this.props.rowId, this.props.leftColumn.id, PageBuilderConstants.UP);
        PageBuilderActions.resizeColumn(this.props.rowId, this.props.rightColumn.id, PageBuilderConstants.DOWN);
      } else {
        PageBuilderActions.resizeColumn(this.props.rowId, this.props.leftColumn.id, PageBuilderConstants.DOWN);
        PageBuilderActions.resizeColumn(this.props.rowId, this.props.rightColumn.id, PageBuilderConstants.UP);
      }
    }
  }

  _start(event, ui) {
    this.offset = ui.offset;
  }

};

export default ResizeHandle
